import './Card.css'
import { FaLongArrowAltRight, FaEye } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { Api } from '../Api/Api'
import Img from './Img'


const Card = ({ data }) => {
    const handleCounter = async () => {
        fetch(`${Api}/house/${data.id}`, {
            method: "PUT",
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify({ ...data, veiws: data.veiws + 1 })
        }).then((res) => {
            // console.log(res)
        })
    }
    return (
        <div className="box">
            <Img src={`${Api}/assets/images/${data.file}`} loading='lazy' alt={data.file} />
            <div className="state">{data.state}</div>
            <div className="views">{data.veiws} <FaEye /></div>

            <div className="content">
                <div className="card-content">

                    <div className="card-price">
                        <strong style={{ "marginRight": "10px" }}>{data.price}</strong>{data.state === "For Rent" ? "/Month" : data.state === "For Mortgage" ? "For Three Years" : ""}
                    </div>

                    <h3 className="h3 card-title">
                        <div>New Apartment Nice View</div>
                    </h3>

                    <p className="card-text">
                        Beautiful Huge 1 Family House In Heart Of Westbury. Newly Renovated With New Wood
                    </p>

                    <ul className="card-list">
                        <li className="card-item">
                            <span>{data.city}</span>
                        </li>

                        <li className="card-item">
                            <strong>{data.area}</strong>
                            <span style={{ "marginLeft": "10px" }}>m <sup>2</sup></span>
                        </li>

                    </ul>

                </div>
            </div>
            <Link to={`/list/${data.id}`} onClick={handleCounter} className="info">
                <div>Read More</div>
                <i><FaLongArrowAltRight /></i>
            </Link>
        </div>
    )
}

export default Card